import login from '../login/index'
import resetPassword from '../resetPassword/index'
import layout from '../layout/index'
import menu from '../menu/index'
import { default as machines, vsClientName as clientName } from 'MACHINEMODULE'
import workorders from '../work-orders/index'
import utils from '../utils/index'
import parts from '../parts/index'
import ui from '../ui/index'
import users from '../user/index'
import properties from '../property'
import { moduleName as recordsModuleName } from '../records'
import { vsName as userProfileModuleName } from '../application/userProfileModule'
import { vsName as reportingModuleName } from '../reporting'
import contactBook from '../ContactBook/index'
 
import uiRouter from '@uirouter/angularjs/lib-esm'
/* ui-select doesn't export module.  Run this for side effects and manually include below*/
import 'ui-select/dist/select'
//import 'angular-ui-tree/dist/angular-ui-tree'

import ngAnimate from 'angular-animate'
import ngMessages from 'angular-messages'
import uiBootstrap from 'angular-ui-bootstrap'
import uiBootstrapDatetimepicker from 'bootstrap-ui-datetime-picker'

import { menuConfig, menuRun } from './menu'

import { routeConfig } from './routes'

import uiDefaults from './ConfigUiDefaults'
import httpResponseDateConverterInterceptor from './httpResponseDateConverterInterceptor'
import baseUrlInterceptor from './baseUrlInterceptor'
import authenticationHttpInterceptor from './authentication/httpInterceptor'
import uiRouterAuthentication from './authentication/uiRouter'

import { vsBootstrapModuleName } from "./names"

var dependencies = [
  vsBootstrapModuleName,
  login,
  resetPassword,
  layout,
  menu,
  machines,
  workorders,
  recordsModuleName,
  users,
  utils,
  parts,
  contactBook,
  ui,
  uiRouter,
  'ui.select',
  ngAnimate,
  ngMessages,
  'lr.upload',
  uiBootstrap,
  uiBootstrapDatetimepicker,
  properties,
  userProfileModuleName,
  reportingModuleName,
 // 'ui.tree'
]

var app = angular.module('SlotTrak', dependencies)


app
  .constant("clientName", clientName)
  .config(Config)
  .config(uiDefaults)
  .config(menuConfig)
  .config(routeConfig)
  .run(Run)
  .run(uiRouterAuthentication)
  .run(menuRun)

Run.$inject = ['$rootScope', '$log', 'applicationInfo', '$transitions', '$state', 'clientName']
function Run($rootScope, $log, applicationInfo, $transitions, $state, clientName) {
  $state.onInvalid((to, from, injector) => {
    $log.warn({
      to,
      from,
      injector
    })

    return from
  })

  $transitions.onError({}, transition => {
    const error = transition.error()
    if (!error.redirected) {
      $log.warn(error)
    } else {
      $log.debug(error)
    }
  })

  $transitions.onStart({}, transition => {
    $log.debug(transition)
  })

  $rootScope.isModuleLoaded = function isModuleLoaded(name) {
    return applicationInfo.isModuleLoaded(name)
  }

  $rootScope.clientName = clientName
  
  $rootScope.isFeatureEnabled = function isFeatureEnabled(name){
    return applicationInfo.isFeatureEnabled(name)
  }
}

Config.$inject = ['$httpProvider', '$locationProvider', '$urlRouterProvider', '$logProvider', '$compileProvider']
function Config($httpProvider, $locationProvider, $urlRouterProvider, $logProvider, $compileProvider) {
  $httpProvider.interceptors.push(httpResponseDateConverterInterceptor)
  $httpProvider.interceptors.push(authenticationHttpInterceptor)
  $httpProvider.interceptors.push(baseUrlInterceptor)

  var headers = $httpProvider.defaults.headers
  headers.common.Accept = 'application/json/;text/json;*/*'
  headers.common['Content-Type'] = 'application/json; charset=utf-8'

  $urlRouterProvider.otherwise('/machines')
  $locationProvider.html5Mode({
    enabled: true
  })
  $logProvider.debugEnabled(false)
  $compileProvider.debugInfoEnabled = false
}

export default app.name